<template>
  <van-action-sheet v-model="show" title="付款" @close="onCancel">
    <div class="content">
      <van-radio-group v-model="radio">
        <van-cell-group>
          <!-- 支付宝支付：自定义title插槽，把“标题+value”放左侧  ( v-if="payMayObj && payMayObj.aliPay") -->
          <van-cell 
            icon="alipay" 
            clickable 
            @click="radio = '1'" 
            v-if="payMayObj && (payMayObj.aliPay || payMayObj.yeeAliPay)"
          >
            <!-- 自定义title插槽：标题 + value -->
            <template #title>
              <span class="cell-title">支付宝支付</span>
              <!-- value内容（原value属性移到这里） -->
              <span class="cell-value" v-if="orderInfo && orderInfo.aliPayDisStr">{{ orderInfo.aliPayDisStr || '' }}</span>
            </template>
            <!-- 右侧放radio -->
            <template #right-icon>
              <van-radio name="1" />
            </template>
          </van-cell>

          <!-- 微信支付：同理，自定义title插槽  ( v-if="payMayObj && payMayObj.weChatPay && +isApp" )-->
          <van-cell 
            icon="wechat-pay" 
            clickable 
            @click="radio = '2'" 
            v-if="payMayObj && (payMayObj.weChatPay || payMayObj.yeeWeChatPay) && +isApp"
          >
            <template #title>
              <span class="cell-title">微信支付</span>
              <!-- 微信若有value，同理添加即可 -->
              <span class="cell-value" v-if="orderInfo && orderInfo.wechatPayDisStr">{{ orderInfo.wechatPayDisStr || '' }}</span>
            </template>
            <template #right-icon>
              <van-radio name="2" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
      <van-cell>
        <van-button type="primary" block @click="surePay">{{ radio === '1' ? '支付宝' : '微信' }}支付￥{{ payAmount }}</van-button>
      </van-cell>
    </div>
  </van-action-sheet>
</template>

<script>
export default {
  name: "SelectPayType",
  props: {
    showPayLayer: {
      type: Boolean,
      default: false
    },
    payAmount: {
      type: Number,
      default: 0
    },
    orderInfo: {
      type: Object,
      default: () => {}
    },
    isApp: {
      type: String,
      default: '0'
    }
  },
  data() {
    return {
      radio: "1",
      show: false,
      payMayObj: null
    }
  },
  created() {
    if (this.showPayLayer) {
      this.show = true;
    }
    this.getWXShow()
  },
  methods: {
    getWXShow() {   //   2025-12-18  版本号：v2，先关闭
      this.get('/Base/Pay/GetPayWayIsOpen', {
        isApp: this.isApp ? '1' : '0',
        v:2
      }, 2).then(res => {
        if (res.code === 1) {
          let obj = res.response;
          this.payMayObj = obj;
          if(!obj.aliPay && !obj.yeeAliPay) this.radio = '2';   //2025-12-18  先关闭此条件
          // if (obj.weChatPay && !obj.aliPay) this.radio = '2'
        }
      })
    },
    onCancel() {
      this.$emit('close', true);
    },
    surePay() {
      this.$emit('pay', this.radio);
    }
  },
  watch: {
    showPayLayer(newVal) {
      this.show = newVal;
    }
  }
}
</script>

<style lang="scss" scoped>
.van-action-sheet {
  text-align: left;
  border-radius: 6px 6px 0 0 !important;

  /deep/ .van-action-sheet__content {
    .van-cell {
      // 调整图标、标题、value的布局
      .van-cell__left-icon {
        font-size: 24px;
        margin-right: 10px; // 图标与文字的间距
      }

      // 标题样式
      .cell-title {
        margin-right: 8px; // 标题与value的间距
      }
      // value样式（对应第二个图的“本单立减”）
      .cell-value {
        color: #ff98a0;
        font-size: 12px;
        background: #fff1f2; // 可加背景色更接近示例
        padding: 2px 4px;
        border-radius: 2px;
      }

      .van-icon-alipay {
        color: #53b3f0;
      }
      .van-icon-wechat-pay {
        color: #4fcb77;
      }

      .van-radio__icon--checked {
        .van-icon {
          border-color: #ff98a1;
          background-color: #ff98a1;
        }
      }

      .van-button {
        height: 38px;
        border-radius: 30px;
        border-color: #ff98a1;
        background-color: #ff98a1;
      }
    }
  }
}
</style>